import { useQuery } from 'react-query';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { PATHS } from '@/constants/page-paths';
import { apiGetTwin } from '@/services/chat.api';
import { useChatStore, useSettingsStore, useTwinStore } from '@/store';

export const useTwin = (twin?: string) => {
  const { setTwin, twin: savedTwin } = useTwinStore();

  const { settings } = useSettingsStore();

  const defaultHomePage = settings?.ui?.pages_sections?.defaultHomePage;

  const { state, pathname } = useLocation();

  const { brainId: newCatId } = state || {};

  const { twinName, demoToken } = useParams();

  const { setCategory, category } = useChatStore();

  const navigate = useNavigate();

  const twinParam = twinName || twin || savedTwin?.name;

  const allowedPaths = [PATHS.CHAT, PATHS.SIGN_IN, PATHS.REGISTER];

  const { data, ...others } = useQuery({
    queryKey: ['twin', twinName, demoToken],
    queryFn: () =>
      apiGetTwin({
        twinName: !demoToken ? twinParam : null,
        testToken: demoToken,
      }),
    onSuccess: (res) => {
      setTwin(res?.data?.data);
      const categories = res?.data?.data?.categories;
      const defaultCat =
        categories?.find((cat) => cat?.isDefault) || categories?.[0];

      if (newCatId) {
        const newCategory = categories?.find((i) => i?.brainId === newCatId);
        if (newCategory) {
          setCategory(newCategory);
        }
      } else {
        const isExistingCategoryValid = categories?.some(
          (i: Record<string, string>) => i?.brainId === category?.brainId
        );

        if (!isExistingCategoryValid) {
          setCategory(defaultCat);
        } else {
          const cat = categories?.find(
            (i: Record<string, string>) => i?.brainId === category?.brainId
          );
          setCategory(cat);
        }
      }
    },
    onError: () => {
      if (
        pathname === PATHS.CHAT ||
        pathname.startsWith('/chat/') ||
        pathname.startsWith('/twin-demo/')
      ) {
        navigate(PATHS.HOME);
      }
    },
    refetchOnWindowFocus: false,
    enabled:
      allowedPaths.includes(pathname) ||
      pathname.startsWith('/chat/') ||
      pathname.startsWith('/twin-demo/') ||
      defaultHomePage === 'chat',
  });

  const twinData = data?.data?.data;

  return {
    twinData,
    ...others,
  };
};
